export const mockData = {
  hero: {
    title: "Plus de clients. Moins de tâches répétitives.",
    titleLines: ["Plus de clients.", "Moins de tâches", "répétitives."],
    eyebrow: ["Agence web, IA et cloud", "Lille · Hauts-de-France"],
    copy: "Nous créons les sites web, les outils d'intelligence artificielle et les infrastructures cloud des TPE, PME et indépendants. Et nous commençons toujours par comprendre votre métier.",
    note: "Premier échange de 30 minutes, gratuit et sans engagement.",
    cta: "Parler de mon projet",
    secondaryCta: { label: "Voir ce que l'IA peut faire pour moi", to: "/intelligence-artificielle" }
  },
  home: {
    intro: {
      title: "Une équipe technique qui parle votre langue.",
      text: "Vous n'avez pas besoin de savoir ce qu'est Kubernetes ou un agent IA. Vous avez besoin que votre site vous amène des demandes, que vos équipes arrêtent de recopier des données, et que vos outils ne tombent pas en panne. C'est notre travail."
    },
    pillars: [
      {
        kicker: "Création web",
        title: "Un site qui travaille pour vous.",
        text: "Sites vitrines, e-commerce, applications sur mesure. Pensés pour être trouvés, compris et choisis.",
        to: "/creation-web"
      },
      {
        kicker: "Intelligence artificielle",
        title: "L'IA, utile dès lundi matin.",
        text: "Assistants, agents IA, automatisations. Pour que vos équipes passent leur temps sur ce qui compte.",
        to: "/intelligence-artificielle"
      },
      {
        kicker: "Cloud & DevOps",
        title: "Une infrastructure qui ne vous réveille pas la nuit.",
        text: "AWS, GCP, Kubernetes, CI/CD. Des déploiements automatisés, moins d'incidents et des coûts cloud maîtrisés.",
        to: "/cloud-devops"
      }
    ],
    problems: [
      { quote: "« Mon site ne m'apporte pas de clients. »", answer: "Nous le repensons pour qu'il soit trouvé sur Google, qu'il rassure en quelques secondes et qu'il donne envie de vous contacter.", to: "/creation-web" },
      { quote: "« On perd des heures sur des tâches répétitives. »", answer: "Saisie, relances, tri des emails, préparation des devis : nous repérons ce qui peut être automatisé, puis nous le mettons en place.", to: "/intelligence-artificielle" },
      { quote: "« Je veux utiliser l'IA, mais je ne sais pas par où commencer. »", answer: "Nous identifions avec vous deux ou trois usages vraiment utiles dans votre entreprise. Puis nous les rendons opérationnels.", to: "/intelligence-artificielle" },
      { quote: "« J'ai une idée d'application, mais personne pour la construire. »", answer: "Nous la cadrons, nous développons une première version utilisable, puis nous la faisons évoluer avec vous.", to: "/creation-web" },
      { quote: "« Notre infrastructure devient impossible à maintenir. »", answer: "Nous la simplifions, nous l'automatisons et nous la documentons. Votre équipe reprend la main.", to: "/cloud-devops" },
      { quote: "« Chaque mise en production est longue et stressante. »", answer: "Nous automatisons vos déploiements pour livrer plus souvent, avec moins de risques.", to: "/cloud-devops" },
      { quote: "« Il nous faut un expert technique, pas forcément un CDI. »", answer: "Nous intervenons sur une mission précise ou en accompagnement régulier, selon votre besoin.", to: "/contact" }
    ],
    method: [
      { title: "Nous écoutons.", text: "30 minutes pour comprendre votre activité, votre problème et vos contraintes. Gratuit." },
      { title: "Nous proposons.", text: "Une solution adaptée, un périmètre clair, un devis détaillé. Si une solution simple suffit, nous vous le disons." },
      { title: "Nous construisons.", text: "Par étapes, avec des points réguliers. Vous voyez l'avancement et vous validez au fil de l'eau." },
      { title: "Nous restons là.", text: "Maintenance, évolutions, questions : le même interlocuteur après la livraison." }
    ],
    reasons: [
      { title: "Nous comprenons avant de proposer.", text: "Nous posons des questions sur votre métier avant de parler de technologie." },
      { title: "Toute la chaîne, une seule équipe.", text: "Du site vitrine au cluster Kubernetes : pas de ping-pong entre trois prestataires." },
      { title: "Nous restons pragmatiques.", text: "La bonne solution est souvent la plus simple. Nous ne vendons pas de technologie pour la technologie." },
      { title: "Vous gardez la main.", text: "Code, comptes et données vous appartiennent, et tout est documenté." },
      { title: "Proches de vous.", text: "Basés dans la métropole lilloise, nous travaillons avec des entreprises partout en France." }
    ],
    faqs: [
      { question: "Combien coûte un site web ou un projet IA ?", answer: "Cela dépend du périmètre. Après un premier échange gratuit, vous recevez un devis détaillé, sans surprise." },
      { question: "Je n'y connais rien en technique. Est-ce un problème ?", answer: "Non. C'est même le cas de la plupart de nos clients. Nous vous expliquons chaque choix avec des mots simples et nous prenons en charge la partie technique." },
      { question: "L'IA est-elle adaptée à une petite entreprise ?", answer: "Oui, souvent davantage qu'on ne le pense. Un seul usage bien choisi, comme le traitement des emails ou des factures, peut libérer plusieurs heures par semaine." },
      { question: "Travaillez-vous uniquement avec des entreprises de Lille ?", answer: "Non. Nous sommes basés dans la région lilloise et nous nous déplaçons volontiers dans les Hauts-de-France. Nous accompagnons aussi des entreprises partout en France, à distance." },
      { question: "Pouvez-vous reprendre un site ou une infrastructure existante ?", answer: "Oui. Nous commençons par un état des lieux, puis nous vous disons ce qui peut être conservé, amélioré ou refait." },
      { question: "Combien de temps dure un projet ?", answer: "Un site vitrine prend généralement 2 à 6 semaines. Pour une application, un projet IA ou une migration cloud, le délai est fixé dans le devis, après cadrage." }
    ],
    local: {
      title: "Votre agence web et IA à Lille",
      text: "We Dream Team accompagne les entreprises de la métropole lilloise et des Hauts-de-France : commerces, cabinets, artisans, PME et startups. Nous créons des sites internet, des outils d'intelligence artificielle et des infrastructures cloud, avec un interlocuteur proche de vous. Rencontre sur place à Lille et alentours, suivi à distance partout en France."
    },
    finalCta: {
      title: "Parlons de ce qui vous freine.",
      text: "30 minutes pour comprendre votre situation et vous dire honnêtement ce que nous ferions à votre place. Gratuit et sans engagement."
    }
  },
  about: {
    title: "Votre métier d'abord. La technologie ensuite.",
    description: "Nous sommes une équipe technique basée à Lille. Nous aidons les entreprises à utiliser le web, l'IA et le cloud pour ce qui compte vraiment : gagner des clients et gagner du temps.",
    why: [
      "Trop d'entreprises achètent de la technologie qui ne leur sert pas. Un site impressionnant qui ne ramène personne. Un logiciel complet que personne n'utilise. Une infrastructure taillée pour une multinationale.",
      "Le problème vient rarement de la technique. Il vient d'une question qu'on a oublié de poser : de quoi l'entreprise a-t-elle vraiment besoin ?",
      "Nous commençons par cette question. Toujours."
    ],
    values: [
      { title: "Comprendre avant de construire", text: "Avant de parler de solution, nous voulons comprendre votre activité, vos clients, vos contraintes et vos priorités. C'est ce qui évite les projets qui dérapent." },
      { title: "Rester accessibles", text: "Vous parlez à des personnes qui connaissent votre dossier. Pas à un standard, ni à un chef de projet qui transmet à quelqu'un d'autre." },
      { title: "Choisir la solution la plus simple", text: "Si un outil existant suffit, nous vous le disons. Nous développons sur mesure quand c'est justifié, pas par principe." },
      { title: "Construire pour durer", text: "Code propre, documentation, transmission. Vous devez pouvoir faire évoluer votre outil, avec nous ou sans nous." },
      { title: "Parler clairement", text: "Pas de jargon pour impressionner. Chaque choix technique vous est expliqué avec ce qu'il change pour vous." }
    ],
    chain: [
      "Le web, l'IA et le cloud sont souvent confiés à trois prestataires qui ne se parlent pas. Chez nous, c'est la même équipe.",
      "Concrètement, l'assistant IA de votre site tourne sur une infrastructure que nous avons conçue, et se connecte à vos outils que nous connaissons. Moins d'intermédiaires, moins de pertes d'information, des décisions plus rapides."
    ],
    local: "Nous sommes installés dans la métropole lilloise et rencontrons volontiers nos clients des Hauts-de-France. Pour les entreprises plus éloignées, nous travaillons à distance, avec les mêmes points réguliers et le même interlocuteur."
  },
  services: [
    {
      id: 1,
      title: "Sites Vitrines",
      description: "Des sites élégants et professionnels pour présenter votre activité",
      details: {
        description: "Nous créons des sites vitrines modernes et performants qui mettent en valeur votre activité et attirent vos visiteurs. Chaque site est conçu sur mesure pour refléter votre identité et vos valeurs.",
        features: [
          "Design personnalisé et responsive",
          "Optimisation pour les moteurs de recherche (SEO)",
          "Interface intuitive et moderne",
          "Intégration des réseaux sociaux",
          "Formulaires de contact optimisés",
          "Mises à jour et support technique"
        ],
        benefits: [
          "Présence professionnelle en ligne",
          "Crédibilité renforcée auprès de vos clients",
          "Vitrine accessible 24/7",
          "Facilite la génération de leads"
        ]
      }
    },
    {
      id: 2,
      title: "E-commerce",
      description: "Boutiques en ligne performantes et sécurisées pour vendre vos produits",
      details: {
        description: "Développons votre boutique en ligne avec une solution e-commerce complète, sécurisée et optimisée pour maximiser vos ventes. Gestion des produits, paiements, stocks et commandes simplifiée.",
        features: [
          "Catalogue produit complet et intuitif",
          "Paiement sécurisé (CB, PayPal, etc.)",
          "Gestion des stocks en temps réel",
          "Panier et processus de commande optimisés",
          "Interface d'administration complète",
          "Multi-devises et multi-langues"
        ],
        benefits: [
          "Vendez vos produits 24/7",
          "Expansion de votre marché géographique",
          "Automatisation des processus de vente",
          "Suivi détaillé des performances"
        ]
      }
    },
    {
      id: 3,
      title: "Applications Web",
      description: "Solutions web sur mesure adaptées à vos besoins spécifiques",
      details: {
        description: "Nous développons des applications web sur mesure qui répondent précisément à vos besoins métier. Des solutions évolutives et performantes pour optimiser vos processus.",
        features: [
          "Architecture sur mesure et évolutive",
          "Interface utilisateur intuitive",
          "API RESTful et intégrations",
          "Base de données optimisée",
          "Authentification et sécurité avancées",
          "Tableaux de bord analytiques"
        ],
        benefits: [
          "Automatisation de vos processus",
          "Gain de productivité significatif",
          "Solution adaptée à vos besoins uniques",
          "Évolutivité selon votre croissance"
        ]
      }
    },
    {
      id: 4,
      title: "Design Web",
      description: "Interfaces modernes et intuitives centrées sur l'expérience utilisateur",
      details: {
        description: "Notre équipe de designers crée des interfaces web modernes, esthétiques et fonctionnelles qui offrent une expérience utilisateur exceptionnelle et renforcent votre image de marque.",
        features: [
          "Identité visuelle sur mesure",
          "Maquettes et prototypes interactifs",
          "Design responsive et adaptatif",
          "Optimisation de l'UX/UI",
          "Accessibilité (WCAG)",
          "Guide de style et design system"
        ],
        benefits: [
          "Expérience utilisateur optimale",
          "Image de marque renforcée",
          "Augmentation du taux de conversion",
          "Interface professionnelle et moderne"
        ]
      }
    },
    {
      id: 5,
      title: "Développement Sur Mesure",
      description: "Création de solutions techniques personnalisées et évolutives",
      details: {
        description: "Nous concevons et développons des solutions techniques entièrement personnalisées selon vos besoins spécifiques. Des outils puissants, évolutifs et performants.",
        features: [
          "Analyse approfondie de vos besoins",
          "Architecture technique optimisée",
          "Développement avec technologies modernes",
          "Code propre et maintenable",
          "Tests et qualité garantie",
          "Documentation complète"
        ],
        benefits: [
          "Solution parfaitement adaptée",
          "Performance et rapidité optimales",
          "Maintenabilité à long terme",
          "Évolutivité selon vos besoins"
        ]
      }
    },
    {
      id: 6,
      title: "Refonte de Sites",
      description: "Modernisation et optimisation de votre présence en ligne",
      details: {
        description: "Donnez une seconde vie à votre site web avec une refonte complète. Modernisation du design, amélioration des performances et optimisation de l'expérience utilisateur.",
        features: [
          "Audit complet de l'existant",
          "Nouveau design moderne et responsive",
          "Optimisation des performances",
          "Migration sécurisée des données",
          "Amélioration du SEO",
          "Formation à la nouvelle interface"
        ],
        benefits: [
          "Image moderne et actualisée",
          "Meilleures performances et rapidité",
          "Expérience utilisateur améliorée",
          "Résultats SEO optimisés"
        ]
      }
    },
    {
      id: 7,
      title: "SEO",
      description: "Optimisation pour les moteurs de recherche et visibilité en ligne",
      details: {
        description: "Améliorez votre visibilité sur Google et les autres moteurs de recherche avec notre stratégie SEO complète. Plus de trafic qualifié et une meilleure position dans les résultats.",
        features: [
          "Audit SEO complet du site",
          "Optimisation technique (vitesse, mobile)",
          "Optimisation du contenu et mots-clés",
          "Stratégie de liens entrants (backlinks)",
          "Suivi des performances et reporting",
          "Optimisation locale (Google My Business)"
        ],
        benefits: [
          "Meilleure visibilité en ligne",
          "Trafic organique qualifié",
          "Positionnement durable",
          "ROI mesurable et croissant"
        ]
      }
    },
    {
      id: 8,
      title: "Maintenance",
      description: "Suivi et maintenance technique pour assurer la pérennité de votre site",
      details: {
        description: "Assurez la pérennité et la sécurité de votre site web avec nos services de maintenance. Surveillance, mises à jour, sauvegardes et support technique réactif.",
        features: [
          "Alerte automatique en cas d'indisponibilité",
          "Mises à jour de sécurité régulières",
          "Sauvegardes automatiques quotidiennes",
          "Support technique réactif",
          "Rapports de performance mensuels",
          "Évolution et amélioration continue"
        ],
        benefits: [
          "Site toujours opérationnel",
          "Sécurité renforcée",
          "Tranquillité d'esprit",
          "Performance optimale en continu"
        ]
      }
    },
    {
      id: 9,
      title: "GEO (Visibilité IA)",
      description: "Optimisation pour ChatGPT, Perplexity, Google AI Overviews et autres moteurs de recherche IA",
      details: {
        description: "Faites apparaître votre marque dans les réponses des moteurs IA. Le GEO (Generative Engine Optimization) optimise votre site pour être cité par ChatGPT, Perplexity, Google AI Overviews, Bing Copilot et Claude — là où vos clients posent désormais leurs questions.",
        features: [
          "Audit de visibilité IA (ChatGPT, Perplexity, Google AIO)",
          "Accessibilité aux crawlers IA (GPTBot, ClaudeBot, PerplexityBot)",
          "Implémentation llms.txt et structuration sémantique",
          "Optimisation passage-level pour citations IA",
          "Renforcement des signaux de marque et E-E-A-T",
          "Suivi des mentions et citations dans les réponses IA"
        ],
        benefits: [
          "Visibilité dans les nouvelles surfaces de recherche IA",
          "Trafic qualifié venant des assistants conversationnels",
          "Autorité de marque renforcée auprès des LLM",
          "Avance compétitive sur un canal encore peu exploité"
        ]
      }
    },
    {
      id: 10,
      title: "Agents IA personnalisés",
      description: "Conception d'agents IA sur mesure, connectés à vos outils et à vos données métier",
      details: {
        description: "Automatisez les tâches répétitives et donnez à vos équipes un assistant qui connaît votre entreprise. Nous concevons des agents IA sur mesure, branchés sur vos documents, vos outils et vos processus, pour répondre, rédiger, qualifier ou agir à votre place.",
        features: [
          "Cadrage des cas d'usage et des gains attendus",
          "Agents conversationnels (site web, support client, interne)",
          "Connexion à vos données : documents, base de connaissances, CRM (RAG)",
          "Intégration à vos outils via API (email, agenda, ERP, Slack, Notion…)",
          "Garde-fous, validation humaine et traçabilité des actions",
          "Hébergement conforme RGPD, suivi des coûts et des performances"
        ],
        benefits: [
          "Gain de temps sur les tâches répétitives",
          "Réponses rapides et cohérentes, 24h/24",
          "Connaissance interne accessible à toute l'équipe",
          "Solution évolutive, adaptée à vos processus"
        ]
      }
    }
  ],
  realisations: [
    {
      id: "berulia",
      name: "Berulia",
      category: "E-commerce",
      url: "https://berulia.fr",
      domain: "berulia.fr"
    },
    {
      id: "mbdshop",
      name: "MBD Shop",
      category: "E-commerce",
      url: "https://www.mbdshop.fr",
      domain: "mbdshop.fr"
    },
    {
      id: "mn-esthetique",
      name: "MN Médecine Esthétique",
      category: "Site vitrine",
      url: "https://mn-medecine-esthetique.com",
      domain: "mn-medecine-esthetique.com"
    },
    {
      id: "pluridental",
      name: "Pluridental",
      category: "Cabinet dentaire",
      url: "https://pluridental.fr",
      domain: "pluridental.fr"
    },
    {
      id: "dentaboard",
      name: "Dentaboard",
      category: "Application web",
      url: "https://dentaboard.com",
      domain: "dentaboard.com"
    },
    {
      id: "stop-bullshit-ia",
      name: "Stop Bullshit IA",
      category: "Landing page",
      url: "https://stop-bullshit-ia.com",
      domain: "stop-bullshit-ia.com"
    }
  ],
  contact: {
    title: "Parlez-nous de votre projet",
    subtitle: "Un premier échange de 30 minutes, gratuit et sans engagement. Vous repartez avec un avis clair, même si nous ne travaillons pas ensemble.",
    email: "faycal.zouaoui@wedreamteam.com",
    bookingUrl: "https://calendly.com/zouaoui-faycal-p/reunion-30-minutes",
    zone: "Métropole lilloise et Hauts-de-France sur place, toute la France à distance.",
    agenda: [
      { label: "Votre projet", text: "ce que vous souhaitez construire ou améliorer." },
      { label: "Le problème", text: "ce qui vous freine aujourd'hui." },
      { label: "Vos objectifs", text: "ce qui doit changer, et d'ici quand." },
      { label: "Vos contraintes", text: "délais, outils existants, équipe." },
      { label: "Votre budget", text: "si vous en avez déjà une idée. Sinon, nous vous aiderons à l'estimer." }
    ],
    // Clés envoyées à la Lambda de contact : garder en phase avec SUBJECTS
    // dans terraform/lambda/contact-form/index.mjs.
    subjects: [
      { value: "site", label: "Site internet" },
      { value: "ia", label: "Intelligence artificielle" },
      { value: "automatisation", label: "Automatisation" },
      { value: "odoo", label: "Connecter Odoo à l'IA" },
      { value: "cloud", label: "Cloud & DevOps" },
      { value: "autre", label: "Autre / je ne sais pas encore" }
    ],
    faqs: [
      { question: "Le premier échange est-il vraiment gratuit ?", answer: "Oui. Il sert à comprendre votre besoin et à vous dire si nous sommes les bons interlocuteurs." },
      { question: "Je n'ai pas encore de cahier des charges. Est-ce un problème ?", answer: "Non. Nous vous aidons justement à clarifier le besoin." },
      { question: "Et après l'échange ?", answer: "Si le projet a du sens, vous recevez une proposition écrite avec le périmètre, le délai et le prix." }
    ]
  },
  // Pages piliers : /creation-web, /intelligence-artificielle, /cloud-devops.
  // Rendues par components/PillarPage.jsx.
  pillars: {
    "creation-web": {
      eyebrow: "Création de site internet · Lille et partout en France",
      h1: "Un site internet qui vous amène des clients",
      lead: "Votre site est souvent le premier contact avec un futur client. Nous le concevons pour qu'il soit trouvé, compris en quelques secondes et qu'il donne envie de vous appeler.",
      primary: { label: "Parler de mon site", to: "/contact?sujet=site" },
      secondary: { label: "Voir nos réalisations", to: "/#realisations" },
      sections: [
        {
          title: "Le problème n'est pas d'avoir un site. C'est qu'il travaille.",
          paragraphs: [
            "Beaucoup d'entreprises ont un site. Peu en tirent des clients. Les raisons sont souvent les mêmes : il n'apparaît pas sur Google, il est lent sur mobile, il ne dit pas clairement ce que vous faites, ou il n'invite jamais le visiteur à passer à l'action.",
            "Nous partons de vos objectifs : plus d'appels, plus de demandes de devis, plus de ventes en ligne. Puis nous construisons le site qui sert ces objectifs."
          ]
        },
        {
          title: "Ce que nous créons",
          cards: [
            { title: "Site vitrine", text: "Pour les indépendants, artisans, commerçants et professions libérales. Un site clair qui présente votre activité, rassure vos prospects et facilite la prise de contact.", result: "Une présence crédible et des demandes qui arrivent sans prospection.", to: "/services/creation-site-vitrine" },
            { title: "Site professionnel d'entreprise", text: "Pour les PME qui ont plusieurs offres, plusieurs cibles ou besoin de recruter. Une architecture pensée pour que chaque visiteur trouve vite sa page.", result: "Une image à la hauteur de votre entreprise, et un site qui soutient vos commerciaux.", to: "/services/refonte-site" },
            { title: "E-commerce", text: "Une boutique en ligne simple à gérer : catalogue, paiement sécurisé, suivi des commandes et des stocks.", result: "Des ventes à toute heure, et moins de temps passé sur la gestion.", to: "/services/ecommerce" },
            { title: "Application web", text: "Un outil interne, un espace client, une plateforme de réservation ou un logiciel métier. Nous transformons votre idée ou votre fichier Excel en outil fiable.", result: "Des processus plus rapides et des données centralisées au même endroit.", to: "/services/applications-web" },
            { title: "Développement sur mesure", text: "Quand aucun outil du marché ne colle à votre façon de travailler. Nous développons exactement ce dont vous avez besoin, et nous le connectons à vos outils existants.", result: "Un outil qui s'adapte à vous, et non l'inverse.", to: "/services/developpement-sur-mesure" },
            { title: "Référencement naturel (SEO)", text: "Structure technique, contenus, référencement local et fiche d'établissement Google. Nous aidons aussi votre marque à être citée par ChatGPT et Perplexity.", result: "Des visiteurs qui cherchent déjà ce que vous proposez.", to: "/services/seo" },
            { title: "Maintenance", text: "Mises à jour, sauvegardes, sécurité et petites évolutions. Un interlocuteur qui connaît votre site quand vous avez besoin d'une modification.", result: "Un site qui reste sûr et à jour, sans y penser.", to: "/services/maintenance" }
          ],
          cta: { label: "Parler de mon projet", to: "/contact?sujet=site" }
        },
        {
          title: "Ce que chaque site inclut",
          bullets: [
            "Un design sur mesure, fidèle à votre identité.",
            "Un affichage impeccable sur mobile, tablette et ordinateur.",
            "Les bases du référencement dès la mise en ligne.",
            "Des pages rapides à charger.",
            "Des appels à l'action clairs : appeler, écrire, réserver, acheter.",
            "Une prise en main expliquée, pour modifier vos contenus vous-même."
          ]
        },
        {
          title: "Ils nous ont confié leur site",
          paragraphs: [
            "Pluridental (cabinet dentaire), Dentaboard (application web), MN Médecine Esthétique (site vitrine), Berulia et MBD Shop (e-commerce), Stop Bullshit IA (landing page)."
          ],
          cta: { label: "Voir les sites en ligne", to: "/#realisations" }
        },
        {
          title: "Comment se passe un projet",
          steps: [
            { title: "Échange de découverte", text: "Votre activité, vos clients, vos objectifs." },
            { title: "Proposition et devis", text: "Pages, fonctionnalités, délai et prix, noir sur blanc." },
            { title: "Maquette", text: "Vous validez la structure et le design avant tout développement." },
            { title: "Développement", text: "Vous suivez l'avancement sur une version de test." },
            { title: "Mise en ligne et prise en main", text: "Nous vérifions tout, puis nous vous montrons comment faire vivre votre site." }
          ]
        }
      ],
      faqs: [
        { question: "Combien coûte la création d'un site internet ?", answer: "Le prix dépend du nombre de pages, des fonctionnalités et du niveau de personnalisation. Vous recevez un devis détaillé après un premier échange gratuit." },
        { question: "Combien de temps faut-il pour créer un site ?", answer: "Un site vitrine prend généralement 2 à 6 semaines. Un e-commerce ou une application demande plus de temps. Le délai exact figure dans le devis." },
        { question: "Pourrai-je modifier mon site moi-même ?", answer: "Oui. Nous vous montrons comment mettre à jour vos textes, vos photos et vos actualités. Pour le reste, nous restons disponibles." },
        { question: "Mon site sera-t-il bien référencé sur Google ?", answer: "Chaque site est construit avec les bonnes bases techniques. Pour aller plus loin, nous proposons un accompagnement SEO, notamment en référencement local sur Lille et votre zone." },
        { question: "Pouvez-vous refaire mon site actuel ?", answer: "Oui. Nous analysons d'abord l'existant pour conserver ce qui fonctionne, en particulier votre référencement. Les anciennes adresses sont redirigées pour ne pas perdre de visibilité." },
        { question: "Travaillez-vous avec des cabinets médicaux et dentaires ?", answer: "Oui. Nous avons déjà créé des sites et une application pour des professionnels de santé, avec leurs contraintes de communication et de prise de rendez-vous." }
      ],
      finalCta: {
        title: "Votre site peut faire plus pour vous.",
        text: "Racontez-nous votre activité et ce que vous attendez de votre site. Nous vous disons comment y arriver.",
        primary: { label: "Parler de mon site", to: "/contact?sujet=site" },
        secondary: { label: "Voir le détail de nos services", to: "/services" }
      }
    },
    "intelligence-artificielle": {
      eyebrow: "Intelligence artificielle pour TPE et PME",
      h1: "Mettez l'IA au travail dans votre entreprise",
      lead: "Vos équipes passent encore des heures à recopier, trier, relancer et résumer ? Nous identifions ce qui peut être automatisé et nous mettons en place des outils IA adaptés à votre activité.",
      primary: { label: "Identifier ce que je peux automatiser", to: "/contact?sujet=ia" },
      secondary: { label: "Voir des exemples concrets", to: "#exemples" },
      sections: [
        {
          title: "Tout le monde parle d'IA. Peu de dirigeants savent quoi en faire.",
          paragraphs: [
            "Vous avez testé ChatGPT. Vous sentez que ça pourrait servir. Mais entre les démos impressionnantes et votre quotidien, il manque un pont.",
            "Ce pont, c'est notre métier. Nous partons de vos tâches réelles, pas de la technologie. Nous cherchons ce qui vous coûte du temps chaque semaine. Puis nous construisons l'outil qui s'en charge, connecté à vos logiciels."
          ]
        },
        {
          title: "Ce que l'IA peut faire pour vous",
          cards: [
            { title: "Automatiser les tâches répétitives", text: "Copier une information d'un email vers un tableur, relancer un client, créer une fiche dans le CRM. L'IA le fait, vous validez." },
            { title: "Un assistant qui connaît votre entreprise", text: "Il répond à partir de vos documents : procédures, catalogue, conditions générales, FAQ. Sur votre site pour vos clients, ou en interne pour vos équipes." },
            { title: "Des agents IA qui agissent dans vos outils", text: "Un agent ne se contente pas de répondre. Il peut qualifier une demande, préparer un devis, planifier un rendez-vous. Les actions sensibles restent soumises à votre validation.", to: "/services/agents-ia" },
            { title: "Traiter vos documents", text: "Factures, bons de commande, contrats, CV : l'IA extrait les informations utiles et les range au bon endroit." },
            { title: "Produire du contenu", text: "Fiches produits, réponses types, publications, premiers jets de propositions commerciales. Dans votre ton, à relire avant envoi." },
            { title: "Résumer automatiquement", text: "Réunions, longs fils d'emails, rapports : l'essentiel en quelques lignes, envoyé aux bonnes personnes." },
            { title: "Analyser vos données", text: "Posez vos questions en français sur vos ventes, vos stocks ou vos clients. Obtenez une réponse claire, sans créer de tableau croisé." },
            { title: "Gérer vos emails", text: "Tri automatique, détection des urgences, brouillons de réponse prêts à envoyer." },
            { title: "S'intégrer à vos outils existants", text: "Messagerie, agenda, CRM, ERP, Google Workspace, Microsoft 365, Slack, Notion : l'IA travaille là où vous travaillez déjà. Pas de nouveau logiciel à apprendre." }
          ],
          cta: { label: "Automatiser mon entreprise", to: "/contact?sujet=automatisation" }
        },
        {
          id: "exemples",
          title: "Des exemples concrets, métier par métier",
          table: {
            head: ["Entreprise", "Aujourd'hui", "Avec un outil IA"],
            rows: [
              ["Cabinet dentaire ou médical", "Le secrétariat répond aux mêmes questions au téléphone toute la journée.", "Un assistant sur le site répond aux questions pratiques et oriente vers la prise de rendez-vous."],
              ["Artisan du bâtiment", "Les devis se rédigent le soir, à partir de notes prises sur le chantier.", "Les notes vocales deviennent un brouillon de devis structuré, à vérifier et envoyer."],
              ["Cabinet comptable", "Les pièces arrivent par email et sont saisies à la main.", "Les factures sont lues, classées et pré-saisies automatiquement."],
              ["E-commerçant", "Rédiger des centaines de fiches produits prend des semaines.", "Les fiches sont générées dans votre ton, puis relues."],
              ["PME sous Odoo", "Obtenir un chiffre demande d'exporter, filtrer, croiser.", "Vous posez la question en français et obtenez la réponse directement depuis Odoo."],
              ["Service client", "Les demandes s'empilent dans une boîte partagée.", "Chaque demande est triée, résumée et accompagnée d'un brouillon de réponse."]
            ]
          }
        },
        {
          title: "Zoom : interrogez votre Odoo en français",
          paragraphs: [
            "Votre entreprise utilise Odoo ? Nous déployons un connecteur sur mesure (un serveur MCP) qui permet à un assistant comme Claude d'interroger votre base Odoo, avec les droits que vous décidez.",
            "Concrètement, votre directeur commercial écrit : « Quels clients ont commandé plus de 5 000 € l'an dernier mais rien depuis trois mois ? » L'assistant interroge Odoo, puis renvoie la liste avec les montants et la date de dernière commande. Il peut ensuite proposer un email de relance pour chacun.",
            "Pas d'export, pas de tableau croisé, pas de demande au service informatique. L'accès est en lecture seule par défaut, limité aux modules choisis, et chaque requête est tracée."
          ],
          cta: { label: "Connecter Odoo à l'IA", to: "/contact?sujet=odoo" }
        },
        {
          title: "Notre méthode",
          steps: [
            { title: "Diagnostic gratuit", text: "En une heure, nous passons en revue vos tâches récurrentes et repérons celles où l'IA fera gagner le plus de temps." },
            { title: "Premier cas d'usage", text: "Nous développons une première version sur un besoin précis. Vous la testez en conditions réelles." },
            { title: "Mise en service", text: "Nous l'intégrons à vos outils et formons vos équipes." },
            { title: "Suivi", text: "Nous mesurons ce qui marche, ajustons, puis passons au cas suivant." }
          ]
        },
        {
          title: "Vos données restent sous contrôle",
          bullets: [
            "Nous utilisons des offres professionnelles où vos données ne servent pas à entraîner les modèles.",
            "Nous privilégions un hébergement européen, conforme au RGPD.",
            "Chaque outil n'accède qu'aux données dont il a besoin.",
            "Les actions importantes restent validées par un humain, et tout est tracé."
          ]
        },
        {
          title: "Pourquoi nous confier votre projet IA",
          paragraphs: [
            "Beaucoup de consultants IA s'arrêtent aux recommandations. Nous construisons aussi. Sites, applications, infrastructure cloud : nous maîtrisons toute la chaîne technique nécessaire pour que l'outil IA fonctionne vraiment chez vous, dans la durée."
          ]
        }
      ],
      faqs: [
        { question: "L'IA est-elle adaptée à une petite entreprise ?", answer: "Oui. C'est même dans les petites structures que le gain se voit le plus vite, car chaque heure libérée compte. Un seul usage bien choisi suffit pour commencer." },
        { question: "Faut-il changer nos logiciels ?", answer: "Non. Nous connectons l'IA à vos outils actuels, dès lors qu'ils permettent un accès par API. Nous le vérifions pendant le diagnostic." },
        { question: "Mes données sont-elles en sécurité ?", answer: "Nous choisissons des offres professionnelles où vos données ne servent pas à l'entraînement, limitons les accès au strict nécessaire et privilégions un hébergement européen." },
        { question: "Et si l'IA se trompe ?", answer: "Nos outils répondent à partir de vos propres sources et les citent. Les actions sensibles demandent une validation humaine. Nous testons sur vos cas réels avant la mise en service." },
        { question: "Combien coûte un projet IA ?", answer: "Il y a le développement initial, puis un coût d'usage lié au volume. Nous estimons les deux dès le diagnostic, à partir de votre activité réelle." },
        { question: "Qu'est-ce qu'un serveur MCP ?", answer: "C'est un connecteur standard qui permet à un assistant IA d'accéder à un logiciel, comme Odoo, de façon contrôlée. Vous décidez ce que l'assistant peut lire ou modifier." }
      ],
      finalCta: {
        title: "Identifions gratuitement ce que vous pourriez automatiser.",
        text: "Listez-nous les tâches qui vous prennent le plus de temps. Nous vous disons lesquelles l'IA peut prendre en charge, et comment.",
        primary: { label: "Réserver mon diagnostic IA", href: "booking" },
        secondary: { label: "Échanger avec un expert", to: "/contact?sujet=ia" }
      }
    },
    "cloud-devops": {
      eyebrow: "Cloud & DevOps · AWS, GCP, Kubernetes",
      h1: "Une infrastructure fiable, des déploiements sans stress",
      lead: "Nous aidons les équipes techniques à livrer plus vite, à réduire les incidents et à garder la maîtrise de leurs coûts cloud. En renfort de votre équipe, ou comme votre équipe DevOps.",
      primary: { label: "Faire le point sur mon infrastructure", to: "/contact?sujet=cloud" },
      secondary: { label: "Voir nos domaines d'intervention", to: "#expertises" },
      sections: [
        {
          title: "Les signaux qui ne trompent pas",
          bullets: [
            "Une mise en production mobilise deux personnes et une soirée.",
            "Personne n'ose modifier la configuration de production.",
            "La facture cloud augmente chaque mois, sans explication claire.",
            "Vous apprenez les pannes par vos clients.",
            "Toute la connaissance de l'infrastructure repose sur une seule personne."
          ],
          paragraphs: [
            "Si l'un de ces points vous parle, votre infrastructure vous coûte plus qu'elle ne devrait. En temps, en argent et en sérénité."
          ]
        },
        {
          id: "expertises",
          title: "Ce que nous mettons en place",
          cards: [
            { title: "CI/CD et automatisation des déploiements", text: "GitHub Actions, GitLab CI : chaque modification est testée puis déployée automatiquement.", result: "Vous livrez plusieurs fois par jour si besoin, sans intervention manuelle." },
            { title: "Infrastructure as Code avec Terraform", text: "Votre infrastructure décrite dans du code versionné, relu et reproductible.", result: "Chaque changement est traçable, et un environnement se recrée en quelques minutes." },
            { title: "Kubernetes", text: "Conception, migration et exploitation de clusters (EKS, GKE). Et quand Kubernetes n'est pas nécessaire, nous vous le disons.", result: "Des applications qui montent en charge et se réparent seules." },
            { title: "AWS et GCP", text: "Architecture, comptes, réseau, IAM, services managés.", result: "Une base saine, sécurisée et documentée, sur laquelle votre équipe peut construire." },
            { title: "Migration vers le cloud", text: "Depuis vos serveurs ou d'un fournisseur à un autre, par étapes, avec une bascule au moment qui vous convient.", result: "Une bascule préparée, testée et réversible." },
            { title: "Monitoring et alerting", text: "Métriques, logs, tableaux de bord, alertes utiles.", result: "Vous détectez les problèmes avant vos clients." },
            { title: "Sécurité", text: "Moindre privilège, gestion des secrets, déploiements sans clés statiques (OIDC), chiffrement, sauvegardes.", result: "Une surface d'attaque réduite et des accès maîtrisés." },
            { title: "Optimisation des coûts cloud", text: "Analyse de la facture, redimensionnement, arrêt des ressources inutiles, choix des bons modèles de tarification.", result: "Vous payez ce que vous utilisez, et vous savez pourquoi." }
          ],
          cta: { label: "Échanger avec un expert DevOps", to: "/contact?sujet=cloud" }
        },
        {
          title: "Comment nous intervenons",
          cards: [
            { title: "Audit", text: "Un état des lieux de votre infrastructure, de vos déploiements et de vos coûts, avec un plan d'action priorisé." },
            { title: "Mission", text: "Un objectif précis et un livrable : pipeline CI/CD, migration, mise en place de Terraform ou de Kubernetes." },
            { title: "Accompagnement régulier", text: "Un expert DevOps quelques jours par mois, sans recrutement à temps plein." }
          ],
          paragraphs: [
            "Dans tous les cas, nous documentons et transmettons. Votre équipe doit pouvoir se passer de nous."
          ]
        },
        {
          title: "Notre façon de travailler",
          bullets: [
            "Pragmatique : la solution la plus simple qui répond au besoin. Pas de Kubernetes pour trois conteneurs.",
            "Transparent : chaque changement passe par une revue de code et un plan relu.",
            "Transmissible : code, documentation et accès vous appartiennent."
          ]
        }
      ],
      faqs: [
        { question: "Intervenez-vous sur une infrastructure existante ?", answer: "Oui, c'est le cas le plus fréquent. Nous commençons par un audit, puis nous améliorons par étapes, sans tout reconstruire." },
        { question: "Pouvez-vous travailler avec notre équipe technique ?", answer: "Oui. Nous intervenons en renfort, dans vos outils et vos rituels. L'objectif est aussi de faire monter votre équipe en compétence." },
        { question: "Kubernetes est-il indispensable ?", answer: "Non. Pour beaucoup d'applications, des services managés plus simples suffisent et coûtent moins cher. Nous recommandons Kubernetes quand il apporte un vrai bénéfice." },
        { question: "Comment réduire notre facture AWS ou GCP ?", answer: "En commençant par comprendre où part l'argent. Un audit des coûts identifie les ressources surdimensionnées, inutilisées ou mal tarifées." },
        { question: "Faut-il recruter un DevOps à temps plein ?", answer: "Pas forcément. Un accompagnement régulier couvre souvent le besoin d'une PME ou d'une startup, pour un coût maîtrisé." }
      ],
      finalCta: {
        title: "Votre infrastructure mérite un deuxième avis.",
        text: "Expliquez-nous votre architecture et ce qui vous freine. Nous vous disons par quoi nous commencerions.",
        primary: { label: "Faire le point sur mon infrastructure", to: "/contact?sujet=cloud" },
        secondary: { label: "Réserver un échange", href: "booking" }
      }
    }
  }
};